import { ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { ConfirmationDialogComponent } from 'src/app/Shared/confirmation-dialog/confirmation-dialog.component';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { ALERT_TYPE } from 'src/app/constants';
import { LoanScheme } from '../../../model/loanScheme.model';

@Component({
    selector: 'app-add-plan',
    templateUrl: './add-plan.component.html',
    styleUrls: ['./add-plan.component.scss'],
    standalone: false
})
export class AddPlanComponent implements OnInit {
  private cdr = inject(ChangeDetectorRef);
  private activeModal = inject(NgbActiveModal);
  private restapi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);
  protected sharedService = inject(SharedService);

  loanSchemeList: LoanScheme[] = [];

  //2 way binding from html view
  loanSchemeName: string;
  loanSchemeInterest: number;
  loanSchmemeTerm: string;

  schemeNameNull: boolean;
  schemeInterestNull: boolean;
  schemeTermNull: boolean;

  disabledSubmit = false;

  ngOnInit() {
    this.getAllLoanSchemes();
  }

  createLoanScheme() {
    this.disabledSubmit = true;
    const data = { "name": this.loanSchemeName, "term": this.loanSchmemeTerm, "interest": this.loanSchemeInterest };
    const xhr = this.restapi.postRequest(this.constructApi.getAddLoanScheme(), data);
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        this.disabledSubmit = false;
        if (xhr.status == 200) {
          const json = JSON.parse(xhr.responseText);
          const loanScheme = new LoanScheme(json.id, json.name, json.term, json.interest);

          this.loanSchemeList = this.loanSchemeList.concat(loanScheme);

          this.resetValues();
        } else {
          this.sharedService.openErrorMessage(xhr);
        }
      }
    }

    // xhr.send(data);
  }

  openDeleteConfirmationDialog(scheme: LoanScheme) {
    const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
    modalRef.componentInstance.message = "Are you sure you want to delete " + scheme.Name + " ?";

    modalRef.result.then((confirm) => {
      if (confirm)
        this.deleteScheme(scheme);
    });
  }

  deleteScheme(scheme: LoanScheme) {
    // var xhttp = new XMLHttpRequest();
    // var url = "http://localhost:10080/api/v1/loanScheme/" + scheme.ID;
    // xhttp.open("DELETE", url, true);
    // xhttp.withCredentials = true;
    // xhttp.setRequestHeader("Content-type", "application/json");

    const xhttp = this.restapi.deleteRequest(this.constructApi.getDeleteLoanScheme(scheme.ID));
    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        for (const i in this.loanSchemeList) {
          if (this.loanSchemeList[i].ID == scheme.ID) {
            this.loanSchemeList.splice(Number(i), 1);
            this.cdr.detectChanges();
          }
        }
      }
    };

    // xhttp.send();
  }

  getAllLoanSchemes() {
    // var xhttp = new XMLHttpRequest();
    // var url = "http://localhost:10080/api/v1/loanSchemes";
    // xhttp.withCredentials = true;

    const xhttp = this.restapi.getRequest(this.constructApi.getAllLoanSchemes())
    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        // Typical action to be performed when the document is ready:
        //  document.getElementById("demo").innerHTML = xhttp.responseText;
        // console.log(this.responseText);

        const jsonArray = JSON.parse((xhttp.responseText));
        // console.log(jsonArray);

        jsonArray.forEach(json => {
          const loanScheme = new LoanScheme(json.id, json.name, json.term, json.interest);
          this.loanSchemeList.push(loanScheme);
        });
      }
    };
    // xhttp.open("GET", url, true);
    // xhttp.send();
  }

  isInvalid() {
    this.schemeNameNull = (this.loanSchemeName == undefined || this.loanSchemeName === '');
    this.schemeTermNull = (this.loanSchmemeTerm == undefined);
    this.schemeInterestNull = (this.loanSchemeInterest == undefined);
    const termValid = isNaN(+this.loanSchmemeTerm)
    const interestValid = isNaN(+this.loanSchemeInterest)

    return (this.schemeNameNull || this.schemeTermNull || this.schemeInterestNull || termValid || interestValid);
  }

  submit() {
    this.isInvalid() ? this.sharedService.openAlert('Please fill in all the fields!', ALERT_TYPE.DANGER) : this.createLoanScheme();
  }

  reset() {
    this.activeModal.close();
    this.resetValues();
  }

  resetValues() {
    this.loanSchemeName = undefined;
    this.loanSchemeInterest = undefined;
    this.loanSchmemeTerm = undefined;
  }
}
